import usePagination from '@/hooks/usePagination';
import { OrderEnum, TagPaginatedOptionsFilters } from '@/types/schema';

import { useTagOptionsQuery } from '../../graphql/queries/generated/tagOptions';

const useTagOptions = (filters: TagPaginatedOptionsFilters, pause?: boolean) => {
  const { isLoading, error, fetchMore, data, isFetchingMore } = usePagination(
    useTagOptionsQuery,
    {
      filters,
      sort: [{ field: 'updatedAt', order: OrderEnum.Desc }],
    },
    { edgeKey: 'tagOptions', pause },
  );

  return {
    error,
    tagOptions: data,
    fetching: isLoading,
    fetchMore,
    isFetchingMore,
  };
};

export default useTagOptions;
